module.exports = __webpack_public_path__ + "static/media/banner-limelocker.4ff38bbb.webp";